module.exports = __webpack_public_path__ + "img/business_capabilities_application_architecture.e89adaaf.gif";